import * as React from 'react';
import { withLocalize, LocalizeContextProps, Translate } from "react-localize-redux";
import bindAllOfThis from 'src/utils/BindThisHelper';
import Routes from 'src/core/Routes';
import { Row, Col, Button } from "antd";
import DialogBox from "src/components/mission/DialogBox";
import { EnhancedProps } from 'src/pages/student/models/props';
import InfoBox from "src/components/mission/InfoBox";
import { Link } from "react-router-dom";
import { Planets } from "src/constants/Planets";
import { Grades } from "src/constants/Grades";
import AudioTranslations from "src/constants/AudioTranslations";

interface SpaceStationCompleteProps extends EnhancedProps, LocalizeContextProps {
}

class SpaceStationComplete extends React.Component<SpaceStationCompleteProps> {
    constructor(props: SpaceStationCompleteProps) {
        super(props);
        bindAllOfThis(this, SpaceStationComplete.prototype);
    }

    private renderBadges() {
        // Use C as it's the last planet
        return Planets.GetPlanetListByPlanetId(Planets.C.id).map(planet => (
            <img className="badge" alt="Planet Badge" src={planet.badgePath} key={`badge${planet.id}`} />
        ));
    }

    /**
     * Visible for grades 4+
     */
    renderTrainingAndEducationGuideButton() {
        if (this.props.currentGrade.level >= Grades.Fourth.level) {
            return <Link to={Routes.getRoute(Routes.TRAINING_AND_EDUCATION_GUIDE, this.props.Mission.current.planetId)}>
                <Button size="small">
                    <Translate id="common.trainingAndEducation" />
                </Button>
            </Link>;
        }
    }

    /**
     * Visible for grades 3+
     */
    renderOccupationDb() {
        if (this.props.currentGrade.level >= Grades.Third.level) {
            return (<Link to={Routes.OCCUPATIONDB}>
                <Button size="small">
                    <Translate id="public.occupationdb.title" />
                </Button>
            </Link>);
        }
    }

    /**
     * Visible for grades 3+
     */
    renderHollandGuideButton() {
        if (this.props.currentGrade.level >= Grades.Third.level) {
            return <Link to={Routes.getRoute(Routes.HOLLAND_AREAS_GUIDE, this.props.Mission.current.planetId)}>
                <Button size="small">
                    <Translate id="common.hollandAreas" />
                </Button>
            </Link>;
        }
    }

    render() {
        let translationKey = "student.galaxyEnd.doneWithGrade";
        let audioTrans = AudioTranslations.FindByKeyAndLanguage(translationKey + "Complete", this.props.activeLanguage.code);
        this.props.onChangeAudio(audioTrans.url);

        return <Row className="mission-complete">
            <Col className="dialog-content" xs={{ span: 22, push: 1 }} md={{ span: 16 }} xl={14}>
                <Row>
                    <DialogBox
                        currentGrade={this.props.currentGrade}
                        currentPlanet={this.props.currentPlanet}
                        onNext={null}>
                        <h2 className="galaxyEnd-header"><Translate id="student.galaxyEnd.title" /></h2>
                        <p className="galaxyEnd-body"><Translate id={translationKey} /></p>
                        <Row>
                            <Col xs={13} xl={13} xxl={15}>
                                <h3><Translate id="student.galaxyEnd.badges" /></h3>
                                {this.renderBadges()}
                            </Col>
                            <Col xs={11} xl={11} xxl={9}>
                                <h3><Translate id="common.menu" /></h3>
                                <div className="resource-buttons">
                                    <Link to={Routes.STATEMENTS}>
                                        <Button size="small">
                                            <Translate id="admin.sideNav.iStatementsText" />
                                        </Button>
                                    </Link>
                                    {this.renderOccupationDb()}
                                    {this.renderHollandGuideButton()}
                                    {this.renderTrainingAndEducationGuideButton()}
                                </div>
                            </Col>
                        </Row>
                        <h3><Translate id="student.galaxyEnd.conclusion" /></h3>
                    </DialogBox>
                </Row>
            </Col>
            <Col xs={23} md={{ span: 7, push: 1 }} xl={9}>
                <Row type="flex" justify="space-between">
                    <Col xs={{ span: 23, push: 1 }} lg={{ span: 20, push: 4 }}>
                        <InfoBox currentGrade={this.props.currentGrade} currentPlanet={this.props.currentPlanet} />
                    </Col>
                </Row>
                <Row type="flex" justify="space-between">
                    <Col xs={{ span: 20, push: 2 }} lg={{ span: 21, push: 1 }}>
                        <img className="station-commander" alt={`Commander ${this.props.currentGrade.commander}`} src={this.props.currentGrade.commanderPath} height="100%" width="100%" />
                    </Col>
                </Row>
            </Col>
        </Row>;
    }
}

export default withLocalize(SpaceStationComplete);



// WEBPACK FOOTER //
// ./src/pages/student/scenes/SpaceStationComplete.tsx